<template>
  <div class="body">
    <div class="top-title">
      <img src="@/assets/icon/notice.png" />
      <div>项目公告</div>
    </div>
    <div class="container">
      <div class="announcement" v-for="item in list" :key="item.id">
        <div class="announcement-item" @click="toDetail(item)">
          <div class="title">{{item.title}}</div>
          <div class="date">{{item.publicTime}}</div>
        </div>
      </div>
      <Pagination
        :total="paginationParam.total"
        :page.sync="paginationParam.pageIndex"
        :limit.sync="paginationParam.pageSize"
        @pagination="getListData"
      />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  components: { Pagination },
  data() {
    return {
      paginationParam: {
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      list: [],
      formInfo: {
        title: "",
        topStatus: "",
        beginTime: "",
        endTime: ""
      },
      Total: 0
    };
  },
  methods: {
    toDetail(item) {
      this.$router.push({
        name: "ProjectAnnouncementDetail",
        query: { id: item.id }
      });
    },
    getListData() {
      let data = {
        pageNum: this.paginationParam.pageIndex,
        pageSize: this.paginationParam.pageSize,
        userId: this.$store.state.userInfo.id,
        areaConfigId: this.$store.state.cityArea.areaConfigId,
        systemConfigName: "rural"
      };
      this.$api.trade.getProjectList(data).then(res => {
        this.list = res.data;
        this.paginationParam.total = res.total;
      });
    }
  },
  mounted() {
    this.getListData();
  }
};
</script>

<style lang="scss" scoped>
.body {
  padding: 20px;
  background: #fff;
}
.top-title {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #f65248;
  background: rgba($color: #e3e6ea, $alpha: 0.2);
  line-height: 56px;
  position: relative;
  display: flex;
  align-items: center;
  width: 1110px;
  padding-left: 20px;
  margin: 18px auto 24px;
  img {
    margin-right: 7px;
  }
}
.top-title::before {
  display: none;
}
.container {
  width: 1100px;
  margin: 0 auto;
  min-height: 500px;
  .announcement {
    padding: 15px 0;
    border-bottom: 1px solid #ebecef;
    cursor: pointer;
    &:last-child {
      border: none;
    }
    .announcement-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      line-height: 30px;

      &::before {
        content: " ";
        width: 6px;
        height: 6px;
        // background: linear-gradient(
        //   135deg,
        //   rgba(255, 112, 103, 1) 0%,
        //   rgba(239, 81, 71, 1) 100%
        // );
        border: 2px solid #C5323E;
        border-radius: 50%;
        position: absolute;
        left: -20px;
      }
      .title {
        font-family: PingFangSC-Medium;
        font-size: 17px;
        font-weight: bold;
        color: #2e2e2e;
        width: 680px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .date {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(96, 105, 126, 1);
      }
    }
  }
}
</style>